'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Functions = require('../core/Functions');

var _LightColors = require('../core/LightColors');

var _LightColors2 = _interopRequireDefault(_LightColors);

var _MediumColors = require('../core/MediumColors');

var _MediumColors2 = _interopRequireDefault(_MediumColors);

var _NormalColors = require('../core/NormalColors');

var _NormalColors2 = _interopRequireDefault(_NormalColors);

var _Style = require('../core/Style');

var _underscore = require('../utils/underscore');

var _passthroughProps = require('../utils/propTypes/passthroughProps');

var _passthroughProps2 = _interopRequireDefault(_passthroughProps);

var _UICloseButton = require('../button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _UILink = require('../link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UITruncateString = require('../text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _colors = require('HubStyleTokens/colors');

var _misc = require('HubStyleTokens/misc');

var _sizes = require('HubStyleTokens/sizes');

var _theme = require('HubStyleTokens/theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USE_CLASSES = {
  // These do not come from the sketch file
  default: 'tag-default private-tag--disabled private-tag--default',
  primary: 'tag-primary private-tag--disabled',
  info: 'tag-info private-tag--info',

  disabled: 'private-tag--disabled',
  success: 'tag-success private-tag--success',
  warning: 'tag-warning private-tag--warning',
  danger: 'tag-danger private-tag--danger',

  calypso: 'private-tag--calypso',
  sorbet: 'private-tag--sorbet',
  lorax: 'private-tag--lorax',
  marigold: 'private-tag--marigold',
  'candy-apple': 'private-tag--candy-apple',
  norman: 'private-tag--norman',
  thunderdome: 'private-tag--thunderdome',
  oz: 'private-tag--oz',
  olaf: 'private-tag--olaf'
};

var STATUS_ALIAS_MAP = {
  paused: 'disabled',
  draft: 'disabled',
  active: 'success',
  sent: 'success',
  published: 'success',
  inReview: 'warning',
  scheduled: 'warning',
  removed: 'danger',
  cancelled: 'danger',
  error: 'danger'
};

var USE_COLOR_ALIAS_MAP = {
  // defaults
  disabled: 'default',
  paused: 'default',
  draft: 'default',
  primary: 'default',
  // oz
  success: 'oz',
  active: 'oz',
  sent: 'oz',
  published: 'oz',
  // marigold
  warning: 'marigold',
  inReview: 'marigold',
  scheduled: 'marigold',
  // cand-apple
  danger: 'candy-apple',
  removed: 'candy-apple',
  cancelled: 'candy-apple',
  error: 'candy-apple',
  // calypso
  info: 'calypso'
};

var TAG_BACKGROUND_COLORS = _extends({}, _LightColors2.default, {
  default: _colors.KOALA
});
var TAG_IS_BORDERED_BORDER_COLORS = _extends({}, _MediumColors2.default, {
  default: _colors.BATTLESHIP
});
var TAG_BORDER_COLORS = _extends({}, _NormalColors2.default, {
  default: _colors.BATTLESHIP
});

var getBackgroundColor = function getBackgroundColor(use) {
  return TAG_BACKGROUND_COLORS[use] != null ? TAG_BACKGROUND_COLORS[use] : _colors.KOALA;
};

var getBorderColor = function getBorderColor(use, bordered) {
  if (bordered && TAG_IS_BORDERED_BORDER_COLORS[use] != null) {
    return TAG_IS_BORDERED_BORDER_COLORS[use];
  } else if (TAG_BORDER_COLORS[use] != null) {
    return TAG_BORDER_COLORS[use];
  }
  return 'transparent';
};

var getInlineStyles = function getInlineStyles(inline) {
  return inline ? '\n        margin: 0 4px;\n        vertical-align: bottom;\n      ' : null;
};

var getCloseablePadding = function getCloseablePadding(closeable) {
  return closeable ? '\n        padding-right: 28px !important;\n      ' : null;
};

var renderContents = function renderContents(href, target, onClick, truncatedChildren) {
  var buttonClassName = 'private-tag__link';
  if (href) {
    return _react2.default.createElement(
      StyledLink,
      {
        className: buttonClassName,
        href: href,
        target: target,
        use: 'on-bright'
      },
      truncatedChildren
    );
  } else if (onClick) {
    return _react2.default.createElement(
      LinkStyledClickable,
      { className: buttonClassName, onClick: onClick },
      truncatedChildren
    );
  }

  return _react2.default.createElement(
    ContentWrapper,
    { className: 'private-tag__content-wrapper' },
    truncatedChildren
  );
};

var Tag = _styledComponents2.default.span.withConfig({
  displayName: 'UITag__Tag'
})(['font-size:', ';background-color:', ';border:1px solid ', ';color:', ';line-height:', ';padding:', ' ', ';', ' position:relative;cursor:inherit;display:inline-block;font-weight:', ';max-width:100%;overflow:hidden;user-select:none;> * + *{margin-left:', ';}& + .private-tag{margin-left:', ';}', ''], _sizes.TAG_FONT_SIZE, function (props) {
  return getBackgroundColor(props.computedUse);
}, function (props) {
  return getBorderColor(props.computedUse, props._bordered);
}, function (props) {
  return props.computedUse === 'olaf' ? _colors.OLAF : _theme.BASE_FONT_COLOR;
}, (0, _Style.remCalc)(parseInt(_sizes.TAG_HEIGHT, 10) - 2), _sizes.TAG_PADDING_Y, _sizes.TAG_PADDING_X, function (props) {
  return getCloseablePadding(props.closeable);
}, _misc.WEB_FONT_DEMI_BOLD_WEIGHT, (0, _Style.remCalc)(_sizes.TAG_ICON_SPACING_X), function (_ref) {
  var inline = _ref.inline;
  return inline ? null : (0, _Style.remCalc)(_sizes.BASE_SPACING_X);
}, function (props) {
  return getInlineStyles(props.inline);
});

var FlexWrapper = _styledComponents2.default.span.withConfig({
  displayName: 'UITag__FlexWrapper'
})(['display:inline-flex;max-width:100%;vertical-align:top;']);

var ContentWrapper = _styledComponents2.default.span.withConfig({
  displayName: 'UITag__ContentWrapper'
})(['overflow:hidden;']);

var StyledCloseButton = (0, _styledComponents2.default)(_UICloseButton2.default).withConfig({
  displayName: 'UITag__StyledCloseButton'
})(['bottom:0;color:currentColor;margin-bottom:auto;margin-top:auto;position:absolute;right:', ';top:0;transform:scale(0.5);'], (0, _Style.remCalc)(6));

var StyledLink = (0, _styledComponents2.default)(_UILink2.default).withConfig({
  displayName: 'UITag__StyledLink'
})(['overflow:hidden;']);
StyledLink.displayName = 'StyledUILink';

var LinkStyledClickable = (0, _styledComponents2.default)(_UIClickable2.default).withConfig({
  displayName: 'UITag__LinkStyledClickable'
})(['&&{font-weight:', ';overflow:hidden;text-decoration:underline;}'], _misc.WEB_FONT_MEDIUM_WEIGHT);
LinkStyledClickable.displayName = 'StyledUIClickable';

var UITag = _react2.default.createClass({
  displayName: 'UITag',

  propTypes: {
    children: _react.PropTypes.any,
    closeable: _react.PropTypes.bool.isRequired,
    href: _react.PropTypes.string,
    target: _react.PropTypes.string,
    inline: _react.PropTypes.bool.isRequired,
    multiline: _react.PropTypes.bool.isRequired,
    onCloseClick: _react.PropTypes.func,
    truncateStringProps: (0, _passthroughProps2.default)(_UITruncateString2.default),
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES).concat(Object.keys(STATUS_ALIAS_MAP))).isRequired,
    _avatar: _react.PropTypes.node, // for UIAvatarTag
    _bordered: _react.PropTypes.bool, // for MultiSelect
    _onCloseMouseDown: _react.PropTypes.func // for MultiSelectValue
  },

  getDefaultProps: function getDefaultProps() {
    return {
      _bordered: false,
      closeable: false,
      inline: false,
      multiline: false,
      use: 'default'
    };
  },
  handleCloseClick: function handleCloseClick(evt) {
    var onCloseClick = this.props.onCloseClick;

    (0, _Functions.callIfPossible)(onCloseClick, evt);
  },
  render: function render() {
    var _props = this.props,
        _avatar = _props._avatar,
        _bordered = _props._bordered,
        children = _props.children,
        className = _props.className,
        closeable = _props.closeable,
        href = _props.href,
        inline = _props.inline,
        multiline = _props.multiline,
        onClick = _props.onClick,
        __onCloseClick = _props.onCloseClick,
        __onCloseMouseDown = _props._onCloseMouseDown,
        target = _props.target,
        truncateStringProps = _props.truncateStringProps,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['_avatar', '_bordered', 'children', 'className', 'closeable', 'href', 'inline', 'multiline', 'onClick', 'onCloseClick', '_onCloseMouseDown', 'target', 'truncateStringProps', 'use']);

    this._id = this._id || (0, _underscore.uniqueId)('Tag');

    var truncatedChildren = multiline ? children : _react2.default.createElement(
      _UITruncateString2.default,
      _extends({ useFlex: true }, truncateStringProps),
      children
    );

    return _react2.default.createElement(
      Tag,
      _extends({
        className: (0, _classNames2.default)('tag', 'private-tag', className, USE_CLASSES[STATUS_ALIAS_MAP[use] || use], {
          'private-tag--bordered': _bordered,
          'private-tag--has-close': closeable,
          'private-tag--inline': inline
        }),
        'data-component-name': 'UITag',
        id: this._id,
        computedUse: USE_COLOR_ALIAS_MAP[use] || use,
        _bordered: _bordered,
        closeable: closeable,
        inline: inline
      }, rest),
      _react2.default.createElement(
        FlexWrapper,
        { className: 'private-tag__flex-wrapper' },
        _avatar,
        renderContents(href, target, onClick, truncatedChildren)
      ),
      closeable && _react2.default.createElement(StyledCloseButton, {
        'aria-describedby': this._id,
        className: 'private-tag__close',
        onClick: this.handleCloseClick,
        onMouseDown: this.props._onCloseMouseDown
      })
    );
  }
});

UITag.STATUS_ALIAS_MAP = STATUS_ALIAS_MAP;

exports.default = UITag;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/tag/UITag.js
// module id = 173
// module chunks = 3 4 5